import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
const PatientPracticeDropdown = ({ practice }) => {

    const [isOpen, setIsOpen] = useState(false);

    return (<span key={`${practice.practiceId}-span`}>
        <a
            data-toggle="collapse"
            aria-expanded={isOpen}
            onClick={(e) => {
            e.preventDefault();
                setIsOpen(!isOpen);
            }}
        >
            <span>
                <b className="caret" />
            </span>
        </a>

        <div className="user-info-card-practices" key={`${practice.practiceId}-dropdown`}>
            <Collapse isOpen={isOpen}>
                <div>
                    ID: {practice.practiceId}
                </div>
                <div>
                    External Reference: {practice.patient_ext_ref}
                </div>
                <div>
                    Doctors: {practice.doctors.length}
                </div>
            </Collapse>
        </div>
    </span>)
};

export default PatientPracticeDropdown;